import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ComprehensiveCare from "./sections/ComprehensiveCare";
import UrgentCareFaq from "./sections/UrgentCareFaq";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ComprehensiveCare />
      <UrgentCareFaq />
      <Footer />
    </div>;
}